module.exports = __webpack_public_path__ + "static/media/logo_small.eccb7e11.png";